import { faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type React from "react";
import cn from "mcn";

import { Button } from "./button";

export const Alert = ({
  title,
  message,
  variant,
  action,
  onAction,
  className,
  zIndex,
}: {
  title: string;
  message: React.ReactNode;
  variant: "warning" | "danger";
  action?: string;
  onAction?: () => void;
  className?: string;
  zIndex?: number;
}) => {
  return (
    <div
      role="alert"
      className={cn("shadow-xl rounded-md border select-none", className)}
      style={{
        backgroundColor: "var(--toast-default)",
        color: "var(--toast-foreground)",
        borderColor: "var(--outline-default)",
        display: "flex",
        minWidth: "350px",
        padding: "var(--spacing-scale-medium-500, 15px)",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "flex-start",
        gap: "var(--spacing-scale-small-400, 12px)",
        zIndex: zIndex ?? 10,
      }}
    >
      <div>
        <FontAwesomeIcon
          icon={faTriangleExclamation}
          className={cn({
            "text-danger": variant === "danger",
          })}
          style={{
            width: 32,
            height: 32,
            ...(variant === "warning" ? { color: "var(--semantic-warning)" } : {}),
          }}
          aria-hidden="true"
          focusable="false"
        />
      </div>
      <div
        className="flex-1"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "flex-start",
          gap: "var(--spacing-scale-small-spacing, 3px)",
        }}
      >
        <h4
          style={{
            color: "var(--toast-foreground)",
            fontSize: "var(--font-size-lg, 13.5px)",
            fontWeight: "var(--font-weights-semibold, 600)",
            lineHeight: "var(--line-height-text-lg, 21px)",
          }}
        >
          {title}
        </h4>
        <div>{message}</div>
        {(action || onAction) && (
          <div>
            <Button onClick={onAction} color="neutral">
              {action}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
